import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-cy": "size-choice"
}
const _hoisted_2 = { key: 5 }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_radiolist = _resolveComponent("radiolist")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_segment_button = _resolveComponent("ion-segment-button")!
  const _component_ion_segment = _resolveComponent("ion-segment")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_ctx.menuItem && _ctx.selectedCrust)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ion_card_title, {
          "data-cy": "choose-crust-size-title",
          class: "ion-text-center bold"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Choose Your " + _toDisplayString(_ctx.menuItem.isPizza ? 'Crust' : _ctx.menuItem.isMisc ? _ctx.menuItem.name : _ctx.menuItem.isSub ? 'Bun' : 'Size'), 1)
          ]),
          _: 1
        }),
        (_ctx.menuItem.isPizza)
          ? (_openBlock(), _createBlock(_component_radiolist, {
              key: 0,
              "aria-label": _ctx.menuItem.recipes,
              options: _ctx.menuItem.recipes,
              keyName: "recipeName",
              dense: "",
              modelValue: _ctx.selectedCrust,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCrust) = $event)),
              "data-cy": "choose-size-pizza"
            }, null, 8, ["aria-label", "options", "modelValue"]))
          : _createCommentVNode("", true),
        (_ctx.menuItem.isSub)
          ? (_openBlock(), _createBlock(_component_radiolist, {
              key: 1,
              "aria-label": _ctx.menuItem.recipes,
              options: _ctx.menuItem.recipes,
              keyName: "recipeName",
              dense: "",
              modelValue: _ctx.selectedCrust,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCrust) = $event)),
              "data-cy": "choose-size-pizza"
            }, null, 8, ["aria-label", "options", "modelValue"]))
          : (_ctx.menuItem.isChicken)
            ? (_openBlock(), _createBlock(_component_radiolist, {
                key: 2,
                "aria-labelledby": _ctx.menuItem.recipes[0].sizes.sizePid,
                options: _ctx.menuItem.firstRecipe.sizes,
                keyName: "pieces",
                dense: "",
                modelValue: _ctx.selectedSize,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedSize) = $event)),
                sortKey: "externalId",
                "data-cy": "choose-size-wings"
              }, null, 8, ["aria-labelledby", "options", "modelValue"]))
            : (_ctx.menuItem.isSalad)
              ? (_openBlock(), _createBlock(_component_radiolist, {
                  key: 3,
                  "aria-labelledby": _ctx.menuItem.recipes[0].sizes.sizePid,
                  options: _ctx.menuItem.firstRecipe.sizes,
                  keyName: "partyName",
                  dense: "",
                  modelValue: _ctx.selectedSize,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedSize) = $event)),
                  "data-cy": "choose-size-salad"
                }, null, 8, ["aria-labelledby", "options", "modelValue"]))
              : (_ctx.menuItem.isDessert || _ctx.menuItem.isBeverage || _ctx.menuItem.isAppetizer || _ctx.menuItem.isMisc)
                ? (_openBlock(), _createBlock(_component_radiolist, {
                    key: 4,
                    "aria-labelledby": _ctx.menuItem.recipes[0].sizes.sizePid,
                    options: _ctx.menuItem.firstRecipe.sizes,
                    keyName: "sizeName",
                    dense: "",
                    modelValue: _ctx.selectedSize,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedSize) = $event)),
                    "data-cy": "choose-size-other"
                  }, null, 8, ["aria-labelledby", "options", "modelValue"]))
                : _createCommentVNode("", true),
        (_ctx.menuItem.isPizza)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_ion_item_divider, { class: "ion-margin-vertical" }),
              (_ctx.selectedCrust.sizeDescending && _ctx.selectedCrust.sizeDescending.length > 1)
                ? (_openBlock(), _createBlock(_component_ion_segment, {
                    key: 0,
                    "aria-labelledby": _ctx.menuItem.recipes[0].sizes.sizePid,
                    mode: "ios",
                    value: _ctx.selectedSize,
                    onIonChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectSize($event.target.value))),
                    class: "ion-justify-content-start d-flex"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCrust.sizeDescending, (size) => {
                        return (_openBlock(), _createBlock(_component_ion_segment_button, {
                          "aria-labelledby": _ctx.menuItem.recipes[0].sizes.sizePid,
                          key: size.name,
                          value: size,
                          class: "bold pills",
                          "data-cy": 'button-choose-pizza-size-' + size.name
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              "aria-labelledby": _ctx.menuItem.recipes[0].sizes.sizePid
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(size.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["aria-labelledby"])
                          ]),
                          _: 2
                        }, 1032, ["aria-labelledby", "value", "data-cy"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["aria-labelledby", "value"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_row, {
                class: "ion-justify-content-center",
                "data-cy": "size-description"
              }, {
                default: _withCtx(() => [
                  (_ctx.selectedCrust.sizeDescending.length <= 1)
                    ? (_openBlock(), _createBlock(_component_ion_col, {
                        key: 0,
                        class: "ion-text-center ion-text-capitalize py-0",
                        size: "11"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            innerHTML: _ctx.selectedCrust.recipeName
                          }, null, 8, _hoisted_3),
                          _createTextVNode(" is " + _toDisplayString(_ctx.selectedSize.number) + "\" ", 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-center",
                    size: "11",
                    "data-cy": "legal-description"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_text, { color: "primary" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.selectedCrust.legalDescription), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}